import React, { useEffect } from "react";
import EditRule from "./EditRule.js";
import Auth from "../utils/Auth.js";
import Axios from "axios";
import TableRules from "./TableRules.js";
import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import PrivateRouter from "../utils/PrivateRouter.js";

function Rules({ history }) {
  let { path, url } = useRouteMatch();

  const [oldData, setOldData] = React.useState({
    id: "",
    version: "",
    name: "",
    description: "",
    link: "",
    query: "",
    code: "",
    activated: ""
  });

  const handleClickOpen = (event, rowData) => {
    if (rowData !== undefined) {
      setInputs(rowData.selected);
      setOldData(rowData.selected);
    }
    history.push(`${url}/form`);
  };

  const handleActivatedChange = (event, rule) => {
    var selectedRule = rule.selected;
    var newValue = !selectedRule.activated;
    selectedRule.activated = newValue;

    let url = process.env.REACT_APP_BASE_URL + "/rules/" + selectedRule.id;
    Axios.put(url, selectedRule)
      .then(response => {
        const data = [...entries.data];
        const position = findIndex(data, rule.selected);
        data[position].versions.forEach(el => {
          if (el.version !== selectedRule.version) {
            el.activated = false;
          } else {
            el.activated = response.data.activated;
          }
        });
        setEntries({ data });
      })
      .catch(response => { });
  };

  const handleVersionChange = (event, rule) => {
    const data = [...entries.data];
    const position = data.indexOf(rule);
    var selectedVersion = event.target.value - 1;
    data[position].selected = data[position].versions[selectedVersion];
    setEntries({ data });
  };

  const handleClose = () => {
    handleCleaner();
    history.goBack();
  };

  const findIndex = (ruleList, rule) => {
    if (ruleList.length === 0) return -1;

    var index = 0;

    while (index < ruleList.length && rule.id !== ruleList[index].selected.id)
      index++;

    if (index >= ruleList.length) return -1;

    return index;
  };

  const editRule = () => {
    let url = process.env.REACT_APP_BASE_URL + "/rules/" + inputs.id;
    Axios.post(url, inputs)
      .then(response => {
        const data = [...entries.data];
        const position = findIndex(data, oldData);
        data[position].selected = response.data;
        data[position].versions.forEach(el => {
          el.activated = false;
        });
        data[position].versions.push(response.data);
        setEntries({ data });
        handleClose();
      })
      .catch(response => { });
  };

  const createRule = () => {
    let url = process.env.REACT_APP_BASE_URL + "/rules";
    Axios.post(url, inputs)
      .then(response => {
        var ruleObject = {};
        ruleObject.versions = [];
        ruleObject.versions.push(response.data);
        ruleObject.selected = response.data;
        const data = [...entries.data, ruleObject];
        setEntries({ data });
        handleClose();
      })
      .catch(response => { });
  };

  const save = oldData => {
    if (inputs.id !== undefined) { editRule(); }
    else {
      createRule();
    }
  };

  // Rule
  const [entries, setEntries] = React.useState({
    data: []
  });

  const initState = {
    name: "",
    description: "",
    link: "",
    query: "",
    code: "",
    activated: "true"
  };

  // Form inputs
  const [inputs, setInputs] = React.useState({
    name: "",
    description: "",
    link: "",
    query: "",
    code: "",
    activated: "true"
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
  };

  const handleCleaner = e => {
    setInputs(initState);
    setOldData(initState);
  };

  const processData = data => {
    var rules = {};

    data.forEach(ruleVersion => {
      if (rules[ruleVersion.id] === undefined) {
        var rule = {};
        rule.versions = [];
        rule.versions.push(ruleVersion);
        rules[ruleVersion.id] = rule;
      } else {
        rules[ruleVersion.id].versions.push(ruleVersion);
      }
    });

    Object.entries(rules).forEach(keyvalue => {
      var rule = keyvalue[1];

      var index = 0;
      while (rule.selected === undefined && index < rule.versions.length) {
        if (rule.versions[index].activated)
          rule.selected = rule.versions[index];
        index++;
      }

      if (rule.selected === undefined)
        rule.selected = rule.versions[rule.versions.length - 1];
    });

    return rules;
  };

  useEffect(() => {
    const isAdmin = Auth.isAdmin();
    let source = Axios.CancelToken.source();

    Axios.get(process.env.REACT_APP_BASE_URL + "/rules" + (isAdmin ? "" : "/simple"), {
      cancelToken: source.token
    })
      .then(response => {
        let data = [];
        var result = processData(response.data);
        Object.entries(result).forEach(keyvalue => {
          data.push(keyvalue[1]);
        });
        setEntries({ data: data });
      })
      .catch(function (thrown) { });
    return () => source.cancel();
  }, []);

  return (
    <Switch>
      <Route exact path={path}>
        <TableRules
          {...{
            handleClickOpen,
            handleVersionChange,
            handleActivatedChange,
            entries
          }}
        />
      </Route>
      <PrivateRouter exact path={`${path}/form`} requiredRole="admin">
        <EditRule {...{ handleClose, save, handleChange, inputs }} />
      </PrivateRouter>
    </Switch>
  );
}

export default withRouter(Rules);
